import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DropdownMenu from "../../../DropdownMenu";
import BasePlayerButton from "./BasePlayerButton";
const ShareButton = ({ children }) => {
    return (_jsxs(DropdownMenu, { children: [_jsx(DropdownMenu.Trigger, { asChild: true, children: _jsx("div", { children: _jsx(BasePlayerButton, { label: "Compartilhar", iconName: "share-2" }) }) }), _jsx(DropdownMenu.Content, { align: "end", portal: false, children: children })] }));
};
ShareButton.displayName = "ShareButton";
export default ShareButton;
